import moment from 'moment';
export var now = function () { return moment(); };
export var prevMinute = function () { return moment().add(-1, 'minute'); };
export var prevHour = function () { return moment().add(-1, 'hour'); };
export var yesterday = function () { return moment().add(-1, 'day'); };
export var prevWeek = function () { return moment().add(-1, 'week'); };
export var prevMonth = function () { return moment().add(-1, 'month'); };
export var prevYear = function () { return moment().add(-1, 'year'); };
export var nextMinute = function () { return moment().add(1, 'minute'); };
export var nextHour = function () { return moment().add(1, 'hour'); };
export var tomorrow = function () { return moment().add(1, 'day'); };
export var nextWeek = function () { return moment().add(1, 'week'); };
export var nextMonth = function () { return moment().add(1, 'month'); };
export var nextYear = function () { return moment().add(1, 'year'); };
export var startDay = function () { return moment().startOf('day'); };
export var startMonth = function () { return moment().startOf('month'); };
export var startYear = function () { return moment().startOf('year'); };
export var endDay = function () { return moment().endOf('day'); };
export var endMonth = function () { return moment().endOf('month'); };
export var endYear = function () { return moment().endOf('year'); };
//# sourceMappingURL=moment.helper.js.map